module.exports = __webpack_public_path__ + "static/img/declaration.a456e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/declaration.png
// module id = hFwM
// module chunks = 34